module.exports = __webpack_public_path__ + "img/hat_3.8bfec3ed.png";